import { ENABLED_INCIDENT_TYPES_QUERY } from "@/features/incidents/graphql/enabled-incident-types-query";
import { NewIncident } from "@/features/incidents/new-incident";

export const Route = createFileRoute({
  component: NewIncident,
  loader: async ({ context, params }) => {
    if (context.urqlClient) {
      await context.urqlClient
        .query(ENABLED_INCIDENT_TYPES_QUERY, {
          organizationId: params.orgId,
        })
        .toPromise();
    }
  },
});
